import { Api } from 'models/services/api';
import { UpdateFranchisorQuery } from 'models/services/graphql';

import { FranchisorData, FranchisorDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: FranchisorDataToSave;
};

const RequestQuery = `
  mutation UpdateFranchisor($id: ID!, $input: FranchisorInput!) {
    ${UpdateFranchisorQuery}
  }
`;

type ResponseData = {
  data: {
    updateFranchisor: FranchisorData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: FranchisorData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateFranchisor;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };